import { render, staticRenderFns } from "./deliverysetup.vue?vue&type=template&id=065b85e1"
import script from "./deliverysetup.vue?vue&type=script&lang=js"
export * from "./deliverysetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports